import { call, put, all } from "redux-saga/effects";
import { logoutAPI } from "../api/LogoutCall";
import { logoutSuccess, logoutFailed, LogoutType } from "../actions/LogoutActions";
import { moveToLoginPage } from "../actions/RouteActions";
import { reportError, reportSuccess } from "../actions/ErrorActions";

export function* logoutSaga(action) {
  const result = yield call(logoutAPI);

  try {
    if (result === 200) {
      yield all([
        put(logoutSuccess()),
        put(moveToLoginPage()),
        action.logoutType === LogoutType.ANNOUNCE ? put(reportSuccess("Successfully logged out")) : {},
      ]);
    } else {
      yield all([
        put(logoutFailed()),
        put(reportError("Unable to logout")),
        put(moveToLoginPage()),
      ]);
    }
  } catch (ex) {
    yield all([
      put(logoutFailed()),
      put(reportError("Unable to reach server")),
      put(moveToLoginPage()),
    ]);
  }
}